import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import { Preset } from '../model/preset.model';

@Injectable({ providedIn: 'root' })
export class PresetService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    create(preset: Preset): Observable<Preset | null> {
        return this._http.post<Preset | null>(
            `${this._appConfig.API_ENDPOINTS.REPORT}/presets`,
            preset,
        );
    }

    delete(presetId: string): Observable<boolean> {
        return this._http.delete<boolean>(
            `${this._appConfig.API_ENDPOINTS.REPORT}/presets/${presetId}`,
        );
    }

    list(): Observable<Preset[]> {
        return this._http
            .get<Preset[]>(`${this._appConfig.API_ENDPOINTS.REPORT}/presets`)
            .pipe(
                tap((ret) => {
                    ret?.forEach((r) => {
                        if (r.createdOn != null) {
                            r.createdOn = new Date(r.createdOn);
                        }
                        if (r.updatedOn != null) {
                            r.updatedOn = new Date(r.updatedOn);
                        }
                    });
                }),
            );
    }
}
